export default __webpack_public_path__ + "static/media/trulifLoader.9e36897a.gif";